import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  chatWithSupport: {
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 16px',
  },
  suggestedQuestions: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  chatWithSupportMessageInput: {
    width: '100%',
    maxWidth: 800,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-end',
  },
  dialogPaper: {
    maxWidth: '900px',
  },
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8,
    height: 40,
    width: 40,
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  sendButton: {
    marginLeft: theme.spacing(2),
  },
  suggestedQuestionChip: {
    color: theme.palette.common.white,
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    fontSize: 15,
  },
  footerDisclaimer: {
    maxWidth: 800,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    fontSize: 14,
  },
}));

export default useStyles;
